"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IInvoiceNumberContent_1 = require("../models/invoice/IInvoiceNumberContent");
const ISettingsField_1 = require("../models/invoice/ISettingsField");
const ISettingsFieldType_1 = require("../models/invoice/ISettingsFieldType");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class InvoiceNumberSettingsValidator extends GenericValidator_1.default {
    _settingsFieldTypes = Object.values(ISettingsFieldType_1.ISettingsFieldType);
    _settingsFields = Object.values(ISettingsField_1.ISettingsField);
    _invoiceNumberContents = Object.values(IInvoiceNumberContent_1.IInvoiceNumberContent);
    _invoiceNumberSettingsSchema = joi_1.default.object({
        settingsFieldType: joi_1.default.string()
            .valid(...this._settingsFieldTypes)
            .required(),
        settingsField: joi_1.default.string()
            .valid(...this._settingsFields)
            .when('settingsFieldType', [
            {
                is: ISettingsFieldType_1.ISettingsFieldType.SUFFIX,
                then: joi_1.default.required(),
            },
            {
                is: ISettingsFieldType_1.ISettingsFieldType.PREFIX,
                then: joi_1.default.required(),
                otherwise: joi_1.default.optional(),
            },
        ]),
        customField: joi_1.default.string().when('settingsField', {
            is: ISettingsField_1.ISettingsField.CUSTOM,
            then: joi_1.default.required(),
            otherwise: joi_1.default.optional(),
        }),
        invoiceNumberContent: joi_1.default.string()
            .valid(...this._invoiceNumberContents)
            .required(),
        nextInvoiceNumber: joi_1.default.number().when('invoiceNumberContent', {
            is: IInvoiceNumberContent_1.IInvoiceNumberContent.SEQUENTIAL_NUMBER,
            then: joi_1.default.required(),
            otherwise: joi_1.default.optional(),
        }),
    }).required();
    validate(invoiceNumberSettings) {
        super.validate(invoiceNumberSettings, 'IInvoiceNumberSettings', this._invoiceNumberSettingsSchema);
    }
}
exports.default = InvoiceNumberSettingsValidator;
